module.exports = __webpack_public_path__ + "img/voice-cricle.7448ebbd.svg";